import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { assetUrl, DEFAULT_SITE, shades, useSite } from "@/lib/site";

const upsert = (selector, make) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = make(); document.head.appendChild(el); }
  return el;
};

const applyColours = (primary, accent) => {
  const root = document.documentElement.style;
  Object.entries(shades(primary)).forEach(([k, v]) => root.setProperty(`--brand-${k}`, v));
  Object.entries(shades(accent, true)).forEach(([k, v]) => root.setProperty(`--accent-${k}`, v));
  upsert('meta[name="theme-color"]', () => Object.assign(document.createElement("meta"), { name: "theme-color" })).content = primary;
};

const applyFavicon = (url) => {
  document.head.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => {
    if (!l.dataset.orig) l.dataset.orig = l.href;
    l.href = url || l.dataset.orig;
    if (l.rel === "icon") l.removeAttribute("type");
  });
};

const applyAnalytics = (id) => {
  if (!id || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id);
};

export const SiteBranding = () => {
  const site = useSite();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => { applyColours(site.primary_color || DEFAULT_SITE.primary_color, site.accent_color || DEFAULT_SITE.accent_color); }, [site.primary_color, site.accent_color]);
  useEffect(() => { applyFavicon(assetUrl(site.favicon_url)); }, [site.favicon_url]);
  useEffect(() => {
    const m = upsert('meta[name="google-site-verification"]', () => Object.assign(document.createElement("meta"), { name: "google-site-verification" }));
    m.content = site.gsc_verification || "";
  }, [site.gsc_verification]);
  useEffect(() => { if (!isAdmin) applyAnalytics(site.ga_id); }, [site.ga_id, isAdmin]);
  return null;
};
